import { render } from "./Default.templates.vue?vue&type=template&id=18676829&scoped=true"
import script from "./Default.templates.vue?vue&type=script&lang=js"
export * from "./Default.templates.vue?vue&type=script&lang=js"

import "./Default.templates.vue?vue&type=style&index=0&id=18676829&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18676829"]])

export default __exports__